import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import Footer from '../../../../../components/footer'
import Head from '../../../../../components/head';
import FormCad from '../../../../../components/auth/saude/remume/form_cad'


function CadastrarRemumeSaudeScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar Medicamento Essencial" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarRemumeSaudeScreen;